<template>
    <Dialog v-model:open="open">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {{
                        t("availability.assign_availability.title")
                    }}</DialogTitle
                >
                <!-- <DialogDescription>
                    Make changes to your profile here. Click save when you're
                    done.
                </DialogDescription> -->
            </DialogHeader>

            <div class="mt-3 sm:mt-0 sm:text-left w-full text-center">
                <div class="mt-4">
                    <div>
                        <div class="rounded-md bg-white -space-y-px">
                            <div
                                v-for="(availability, key) in availabilities"
                                :key="availability.id"
                                class="p-4 hover:bg-iron-50 relative flex cursor-pointer border focus:outline-none"
                                :class="{
                                    'rounded-tl-md rounded-tr-md': key === 0,
                                    'rounded-bl-md rounded-br-md':
                                        availabilities.length === key + 1,
                                }"
                                @click="
                                    availability.id ===
                                    eventType.availability_id
                                        ? detachAvailability()
                                        : assignAvailability(availability.id)
                                "
                            >
                                <input
                                    :id="availability.id.toString()"
                                    name="notification-method"
                                    type="radio"
                                    :checked="
                                        eventType.availability_id ===
                                        availability.id
                                    "
                                    class="h-4 w-4 border-iron-300 text-z-orange-600 focus:ring-z-orange-600"
                                />

                                <span class="ml-5 flex flex-col">
                                    <span
                                        id="privacy-setting-0-label"
                                        class="text-sm font-medium block"
                                        >{{ availability.name }}</span
                                    >
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="eventType.availability_id" class="mt-4">
                    <label
                        for="Duration"
                        class="text-sm font-medium text-iron-700 block"
                        >{{
                            t("availability.assign_availability.duration")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <input
                            v-model="duration"
                            type="number"
                            data-cy="duration"
                            name="duration"
                            class="rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm block w-full"
                            placeholder="30"
                        />
                    </div>
                </div>

                <div v-if="eventType.availability_id" class="mt-4">
                    <label
                        for="offset"
                        class="text-sm font-medium text-iron-700 block"
                        >{{
                            t("availability.assign_availability.offset")
                        }}</label
                    >
                    <div class="mt-1 w-full">
                        <input
                            v-model="offset"
                            type="number"
                            data-cy="offset"
                            name="offset"
                            class="rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm block w-full"
                            placeholder="0"
                        />
                    </div>
                </div>
            </div>
            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 rounded-md border-iron-300 bg-iron-900 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-iron-800 focus:ring-z-orange-500 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm inline-flex w-full justify-center border focus:ring-2 focus:ring-offset-2 focus:outline-none"
                    @click="saveAvailabilityEventTypeSettings"
                >
                    {{ t("save") }}
                </button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import { ref } from "vue";
import route from "ziggy-js";
import { useI18n } from "vue-i18n";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";

const { t } = useI18n();

const props = defineProps<{
    eventType: {
        id: number;
        duration: number;
        offset: number;
        availability_id: number;
    };
    availabilities: Array<{
        id: number;
        name: string;
    }>;
}>();

const open = ref(false);
const duration = ref(props.eventType.duration ?? 30);
const offset = ref(props.eventType.offset ?? 0);

const emits = defineEmits(["availability-set"]);

const detachAvailability = () => {
    router.delete("/event-types/" + props.eventType.id + "/availability", {
        onFinish: () => {
            emits("availability-set");
        },
    });
};

const assignAvailability = (availabilityId: number) => {
    router.post(
        "/event-types/" + props.eventType.id + "/availability",
        {
            availabilityId: availabilityId,
        },
        {
            onFinish: () => {
                emits("availability-set");
            },
        },
    );
};

const saveAvailabilityEventTypeSettings = () => {
    router.post(
        route("app.event-types.availability-settings", props.eventType.id),
        {
            duration: duration.value,
            offset: offset.value,
        },
        {
            onFinish: () => {
                emits("availability-set");
                closeModal();
            },
        },
    );
};

const closeModal = () => {
    open.value = false;
};
</script>

<style></style>
